import { Component, OnInit,ViewChild  } from '@angular/core';
import { RouterModule, Router, ActivatedRoute, ParamMap } from '@angular/router';

import * as _ from "lodash";

import { LoginService } from './login.service';
import { LoginModel } from './LoginModel';
import { AlertService } from '../alert/index';
@Component({
  moduleId: module.id,
  templateUrl: './login.html',
})
export class LoginComponent implements OnInit {
  route = 'reporting';
  dashboard = 'dashboard';
  model: any = {};
  error: any = '';
  loginModel: LoginModel;
  message: string;
  errorMessage: string;
  public loading = false;
  constructor(private _route: ActivatedRoute, private router: Router, private _service: LoginService,
     private alertService: AlertService) { 
     }
  ngOnInit(): void {
    localStorage.removeItem('token');
  }
  populateModel(model: any) {
    this.loginModel = <LoginModel>{};
    this.loginModel.username = model.username;
    this.loginModel.password = model.password;
  }
  login(): void {
    this.alertService.clear();
    this.loading = true;
    this.populateModel(this.model);
    this._service.authenticate(this.loginModel).subscribe(res => {
      this.alertService.clear();
      this.loading = false;
      const data = res;
      if (data.jwtResponse.message == 'Success') {
        localStorage.setItem('token', JSON.stringify(data));
        this.router.navigate(['/reporting/dashboard']);
      }
      else {
        this.errorMessage = data.jwtResponse.message;
        this.alertService.error(this.errorMessage);
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts